import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { NOTIFICATION_TYPES } from './constants';
import ActionButton from '../../elements/action-button/ActionButton';

const FormButtons = ({ type, onCancel, onSendTest, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'space-between', mt: 2, mr: -1 }}
    >
      <ActionButton
        clickAction={onSendTest}
        aria-label={
          type === NOTIFICATION_TYPES.EMAIL
            ? 'send test email'
            : 'send test webhook'
        }
      >
        {type === NOTIFICATION_TYPES.EMAIL
          ? t('sendTestEmail', { ns: 'buttons' })
          : t('sendTestWebhook', { ns: 'buttons' })}
      </ActionButton>

      <Box sx={{ display: 'flex', gap: 2, mr: 1 }}>
        <Button variant="text" onClick={onCancel}>
          {t('cancel', { ns: 'buttons' })}
        </Button>
        <ActionButton clickAction={onSubmit}>
          {t('confirm', { ns: 'buttons' })}
        </ActionButton>
      </Box>
    </Box>
  );
};

FormButtons.propTypes = {
  type: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSendTest: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default FormButtons;
